<template>
  <township-container toRoute="patient"></township-container>
</template>

<script>
import TownshipContainer from "@/components/township/TownshipContainer.vue";
export default {
  components: {
    "township-container": TownshipContainer,
  },
};
</script>
